var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthidSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.82,248.95c-4.7,0-9.42-.15-14.11.03-5.81.22-8.78-1.97-8.65-8.17.22-10.12.07-20.25.07-30.35,0-3.16.37-6.3,4.42-6.36,4.02-.04,4.65,3.2,4.7,6.24.15,7.65.25,15.3.03,22.95-.15,4.79,1.72,6.68,6.54,6.52,7.17-.25,14.37-.12,21.55-.04,3.54.03,7.75.18,7.66,4.85-.09,4.21-4.03,4.27-7.36,4.27h-14.86v.06h0Z",
    fill: "#007cdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11,24.45c0-4.47.25-8.93-.06-13.37C.59,4.51,3.03,1.49,10.02,1.75c9.68.39,19.39.15,29.08.13,3.45,0,7.08.33,6.9,4.7-.15,3.87-3.82,4.09-6.81,4.14-7.45.13-14.92.24-22.37.01-4.87-.13-6.71,1.94-6.59,6.64.19,6.94.13,13.87.06,20.81-.03,3.68.27,8.34-4.88,8.32-4.96,0-4.24-4.56-4.29-7.95-.06-4.7-.01-9.41-.01-14.11h.01Z",
    fill: "#007cdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.3,1.9c4.97,0,9.96.15,14.92-.03,5.38-.19,7.81,2.28,7.78,7.53-.06,10.17-.06,20.32-.1,30.49,0,3.11-.33,6.49-4.21,6.71-4.45.25-4.9-3.48-4.97-6.74-.16-6.45-.07-12.89-.1-19.34-.02-6.46-3.39-9.71-10.1-9.74-6.21-.01-12.44.13-18.66-.01-3.23-.07-7.09-.27-6.95-4.78.13-4.03,3.63-4.06,6.71-4.08h15.68Z",
    fill: "#007cdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.19,248.93c-5.2,0-10.41-.03-15.61,0-3.12.03-5.68-1.12-5.75-4.39-.07-3.33,2.67-4.61,5.6-4.67,7.68-.16,15.37-.33,23.03-.03,5.57.22,7.48-1.95,7.23-7.4-.34-7.15-.13-14.31-.04-21.47.04-3.33.61-6.92,4.91-6.83,3.87.09,4.33,3.36,4.33,6.54,0,10.36-.01,20.74,0,31.1,0,4.9-2.43,7.23-7.33,7.19-5.45-.06-10.9,0-16.36,0v-.03h-.01Z",
    fill: "#007cdc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.07,148.62c-3.14-3.32-3.88-7.86-5.51-12.07-1.18-2.84-1.7-5.88-1.69-8.95-.01-3.66-.34-7.44,1.17-11.02,1.84-4.56,4.02-8.86,6.95-12.89.84-1.27,1.6-2.53,2.06-3.89.91-2.66.58-5.52.36-8.28-.51-4.97-.21-10.02.87-15.01,1.31-5.45,2.51-10.96,2.99-16.55.99-4.97,3-9.1,4.51-13.77,2.57-4.6,5.47-9.18,7.71-13.93,2.7-4.87,6.95-8.1,10.84-12.07,1.91-1.95,3.82-3.74,6.11-5.37,6.92-5.45,15.83-7.74,24.15-10.26,3.39-.94,6.77-1.95,10.2-2.74,5.17-1.18,10.52-.71,15.8-.82,3.38-.04,6.77.06,10.08.77,7.78,2.07,15.85,3.45,23.36,6.4,10.41,5.39,19.7,11.83,26.65,21.23,3.47,5.79,7.51,11.42,10.35,17.55,2.81,7.49,3.97,15.6,5.97,23.4,1.51,6.03,2.46,12.24,2,18.31-.16,2.71-.57,5.45-.24,8.14.34,3.23,2.24,6.33,4.23,8.89,3.45,4.6,5.97,10.2,6.42,15.99-.01,3.45.25,6.97-.19,10.41-1.17,4.67-2.78,9.42-5.03,13.64-3.09,5.37-8.65,7.53-12.08,12.42-3.87,6.68-6.71,14.02-10.96,20.41-3.69,5.3-7.92,9.41-12.13,14.56-3.29,3.96-7.66,6.67-11.13,10.38-4.59,5.34-3.44,12.86-2.06,19.22.73,3.74.94,7.93,3.15,11.12,2.72,4.42,8.59,5.06,12.2,8.26,1.09,1.18,1.4,2.78.79,4.06-2.18,5.45-17.36-3.22-19.49-6.37-3.02-4.36-4.97-9.71-5.51-14.96-.63-4.03,1.08-11.7-3.41-13.67-1.43-.48-3.3.04-4.82.46-13.62,3.97-27.26,3.97-40.87.06-6.84-2.35-7.99,1.56-8.19,7.46-.6,5.73-1.66,11.64-3.58,17.12-3.27,6.86-11.56,10.47-18.72,11.85-3.99.33-4.62-4.42-1.76-6.55,1.19-1,2.66-1.59,4.17-2.29,10.95-4.24,10.11-11.19,10.84-21.12.36-2.77,1.25-5.55.9-8.35-.52-5.76-5.78-8.72-9.62-12.36-3.69-3.77-7.32-7.65-10.93-11.49-3.5-3.72-5.87-8.47-8.93-12.47-2.87-3.56-3.97-7.55-5.29-11.89-1.9-6.01-8.6-8.19-12.41-12.73l-.18-.21h-.09ZM205.39,109.96c-2.2-2.02-3.12-5.11-3.23-8.11-.42-6.79-.79-13.59-.81-20.41-.07-3.08-.52-6.13-1.12-9.16-2.11-10.18-4.05-20.8-10.28-29.47-7.72-12.98-19.06-23.65-32.85-28.12-32.32-10.93-72.34-3.9-89.54,29.79-6.15,12.18-9.13,25.46-10.34,38.91-.79,6.77-.33,13.7-1.08,20.41-.58,3.59-3.18,6.4-5.32,9.2-4.02,5.2-5.35,11.57-4.21,17.61,1.06,5.87,4.56,11.3,9.9,15.08,1.21.92,2.49,1.85,3.57,2.89,2.3,2.1,3.47,4.94,4.53,7.8,5.93,15.59,16.49,29.15,29.8,39.3,20.72,14.81,50.44,14.19,70.71-1.19,7.83-6.07,14.37-13.7,20.1-21.5,3.35-5,5.91-10.91,8.77-16.33,1.34-2.63,2.75-5.23,4.65-7.46,2.76-3.29,6.87-5.39,9.41-8.87,6.5-8.49,5.53-22.64-2.49-30.19l-.18-.18Z",
    fill: "#007cdc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.64,
    cy: 36.26,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.5,
    cy: 44.19,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.8,
    cy: 87.33,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.8,
    cy: 117.26,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.52,
    cy: 103.47,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.32,
    cy: 172.14,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.86,
    cy: 103.47,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.86,
    cy: 134.17,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.78,
    cy: 184.9,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.78,
    cy: 150.88,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.9,
    cy: 36.26,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.05,
    cy: 44.19,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.74,
    cy: 87.33,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.74,
    cy: 117.26,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.03,
    cy: 103.47,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.23,
    cy: 172.14,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.7,
    cy: 103.47,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.7,
    cy: 134.17,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.78,
    cy: 184.9,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.78,
    cy: 150.88,
    rx: 6.53,
    ry: 6.51,
    fill: "#7413d1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 131.9,
    y1: 36.26,
    x2: 99.5,
    y2: 44.19,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.8,
    y1: 87.33,
    x2: 99.5,
    y2: 44.19,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.86,
    y1: 103.47,
    x2: 95.8,
    y2: 87.33,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.52,
    y1: 103.47,
    x2: 95.8,
    y2: 87.33,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.8,
    y1: 117.26,
    x2: 120.86,
    y2: 103.47,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.69,
    y1: 103.47,
    x2: 95.8,
    y2: 117.26,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.94,
    y1: 172.5,
    x2: 70.69,
    y2: 103.47,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.86,
    y1: 134.17,
    x2: 130.78,
    y2: 150.88,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.78,
    y1: 184.9,
    x2: 101.94,
    y2: 172.5,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.78,
    y1: 150.88,
    x2: 102.32,
    y2: 172.14,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.86,
    y1: 134.17,
    x2: 120.86,
    y2: 103.47,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 131.9,
    y1: 36.26,
    x2: 162.05,
    y2: 44.19,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.74,
    y1: 87.33,
    x2: 162.05,
    y2: 44.19,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.7,
    y1: 103.47,
    x2: 165.74,
    y2: 87.33,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.03,
    y1: 103.47,
    x2: 165.74,
    y2: 87.33,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.74,
    y1: 117.26,
    x2: 140.7,
    y2: 103.47,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.85,
    y1: 103.47,
    x2: 165.74,
    y2: 117.26,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.62,
    y1: 172.5,
    x2: 190.85,
    y2: 103.47,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.7,
    y1: 134.17,
    x2: 130.78,
    y2: 150.88,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.78,
    y1: 184.9,
    x2: 159.62,
    y2: 172.5,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.78,
    y1: 150.88,
    x2: 159.23,
    y2: 172.14,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.7,
    y1: 134.17,
    x2: 140.7,
    y2: 103.47,
    fill: "none",
    stroke: "#007cdc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2.98px"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthidSignup);
export default __webpack_public_path__ + "static/media/authid-signup.f207c47cfe602a4cf0d26140219f6e08.svg";
export { ForwardRef as ReactComponent };